<template>
  <div class="range-list" >
    <div
     
      v-for="(item, index) in items"
      :key="item.name"
      :class="{'list-item': true, selected: item.selected, active: index === selected}"
      @click="selectItem(index)"
      @keydown.enter="selectItem(index)"
      tabindex="0"
    
    >
  
      <!-- Accordion + rating = star checkbox component -->
      <star-rating-list-item
        v-if="isAccordion && rangetype === 'rating'"
        :item-data="{
          ...item,
          checkbox: { selected: !!item.selected }
        }"
      />

      <!-- Accordion = real checkbox component -->
     <check-box-label-list-item
      v-else-if="isAccordion"
      :item-data="{
        ...item,
        checkbox: { selected: !!item.selected }
      }"
    />

      <!-- Non-accordion = plain label (unchanged behavior) -->
      <span v-else>
        {{ item.label }}
      </span>
    </div>
  </div>
</template>


<script>
  import CheckBoxLabelListItem from "@/components/lists/item-types/CheckBoxLabelListItem";
  import StarRatingListItem from "@/components/lists/item-types/StarRatingListItem";

export default {
	name: "RangeList",
  components: {
  CheckBoxLabelListItem,
  StarRatingListItem
},

	props:{
		'items':{
			type: Array
		},
    view: String,
    rangetype:String
	},
	computed:{
     isAccordion() {
      return  this.view === 'accordion';
    },

		selected(){
			const items = this.items;
			let selected = null;
			for(let i=0; i < items.length; i++){
				const item = items[i];
				if(item.selected && selected === null) selected = i;

			}
			return selected;
		}
	},
	methods:{
	selectItem(index) {
    
  const items = this.items;
  const shouldDeselect = this.items[index].selected && index === this.selected;
  console.log("shouldDeselect",shouldDeselect)
  for (let i = 0; i < items.length; i++) {
    if (shouldDeselect) {
      items[i].selected = false;
    } else {
      items[i].selected = i === index;
      // if (this.rangetype=="pricing" || this.rangetype=="rating")  {
        
      //   // Pricing & Rating
      //   items[i].selected = i === index;
      // } else {
        
      //   // Discount
      //   items[i].selected = i >= index;
      // }
    }
  }

  this.$emit('select', items[index]);
}

	}
}
</script>

<style lang="scss">
	.range-list {
  // DEFAULT — keep as-is
  
  .list-item {
    display: flex;
    justify-content: center;
    align-content: center;
    flex-wrap: wrap;
    height: 35px;
    padding: 16px;
    background-color: #fff;
    cursor: pointer;
    user-select: none;
     
    &.selected {
      background-color: #d5d5d5;

      &.active {
        background-color: red;
        color: #fff;
      }
    }
  }
}

/* ========================================================= 
   Triggered ONLY when view="accordion"
/* =========================================================
   CTC ACCORDION – DISCOUNT / CATEGORY LIST (FIGMA MATCH)
   ========================================================= */

.range-filter[view='accordion'] {

  .range-list {
    display: flex;
    flex-direction: column;
    width: 120vh;
    border: none;

  }

  .list-item {
    justify-content: flex-start !important;
    gap: 6px;
    width:100%;
    font-size: 12px;
    color: #000;
    background: #fff;
    user-select: none;
   
  }
  .list-item.selected {
    background: #F5F5F5;
    color: #1A7F37;
  }
  .list-item:hover {
    background: #F7F7F7;
  }

  .list-item:last-child {
    border-bottom: none;
  }
}


/* Mobile spacing stays intact */
[mode='tablet'],
[mode='mobile'] {
  .range-list {
    padding: 4px 0;
  }
}

</style>
